import Component from '../Component';
import LinksBlock from './LinksBlock';
import childrenInternal from './childrenData/internal';
import childrenExternalKorpus from './childrenData/externalKorpus';
import childrenExternal from './childrenData/external';

class Content extends Component {
	constructor() {
		super();

		this.linksBlockInternal = new LinksBlock();
		this.linksBlockExternalKorpus = new LinksBlock();
		this.linksBlockExternal = new LinksBlock();
	}

	componentDidMount() {
		this.linksBlockInternal.setRefs(this.refs);
		this.linksBlockInternal.componentDidMount();
		this.linksBlockExternalKorpus.setRefs(this.refs);
		this.linksBlockExternalKorpus.componentDidMount();
		this.linksBlockExternal.setRefs(this.refs);
		this.linksBlockExternal.componentDidMount();
	}

	render() {
		return `
            <div class="sidepanel__content--scroll scroll">
                <ul class="sidepanel__items js-side-panel-items">
                    ${this.linksBlockInternal.setChildren(childrenInternal).render()}
                    <li class="sidepanel__gutter" /></li>
                    ${this.linksBlockExternalKorpus.setChildren(childrenExternalKorpus).render()}
                    <li class="sidepanel__gutter" /></li>
                    ${this.linksBlockExternal.setChildren(childrenExternal).render()}
                </ul>
            </div>
        `;
	}
}

export default Content;
